import styles from "./Avatar.module.css";

interface Props {
  size?: number;
  pulsing?: boolean;
  /** Light the eye cut-outs.
   *
   *  Off by default, and deliberately: this mark also sits beside every
   *  single bot message, and a dozen pulsing pairs of eyes scrolling up the
   *  transcript is noise. Only the header and the launcher ask for it. */
  eyes?: boolean;
  /** Quicker, hotter eyes while the assistant is working. */
  thinking?: boolean;
}

export function Avatar({
  size = 44,
  pulsing = false,
  eyes = false,
  thinking = false,
}: Props) {
  return (
    <span className={styles.wrap} style={{ width: size, height: size }}>
      {pulsing && <span className={styles.pulse} />}
      {/* Before .mark in the DOM, so the mark paints over it and the head
          keeps the glow to the eye holes. */}
      {eyes && (
        <span
          className={`${styles.eyes} ${thinking ? styles.eyesThinking : ""}`}
          aria-hidden="true"
        />
      )}
      <span className={styles.mark} role="img" aria-label="Alienware Arena Assistant" />
    </span>
  );
}
